const NOTES = {
  GET_ALL_NOTES: 'getAllScheduledNotesByPlayer' as 'getAllScheduledNotesByPlayer',
  CREATE_SCHEDULED_NOTE: 'createScheduledNote' as 'createScheduledNote',
  STOP_SCHEDULED_NOTE: 'stopScheduledNote' as 'stopScheduledNote',
  GET_ALL_NOTES_BROADCAST: 'broadcast' as 'broadcast',
  DELETE_SCHEDULED_NOTE: 'deleteScheduledNote' as 'deleteScheduledNote',
}

export default NOTES
